import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 50px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalTitle = styled(Typography.Title).attrs({ $variant: '4' })``;
